"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
var React = __importStar(require("react"));
function useControlled(_a) {
    var controlled = _a.controlled, defaultProp = _a.default;
    // isControlled is ignored in the hook dependency lists as it should never change.
    var isControlled = React.useRef(controlled !== undefined).current;
    var _b = React.useState(defaultProp), valueState = _b[0], setValue = _b[1];
    var value = isControlled ? controlled : valueState;
    var setValueIfUncontrolled = React.useCallback(function (newValue) {
        if (!isControlled) {
            setValue(newValue);
        }
    }, []);
    return [value, setValueIfUncontrolled];
}
exports.default = useControlled;
// import * as React from 'react';
// import { ComboBoxArgValue, ComboBoxObject } from '../models/ComboBoxModels';
// // ComboBoxArgValue | string[] | (ComboBoxObject | { id: string; internalId: string; name: string; label: string; selected: boolean; newValue: null; } | undefined)[] | { ...; }[] | undefined
// export default function useControlled({ controlled, default: defaultProp, name, state = 'value' }: {
//   controlled:ComboBoxArgValue | string[] | (ComboBoxObject | { id: string; internalId: string; name: string; label: string; selected: boolean; newValue: null; })[] | undefined, default?: string, name: string, state?: string}) {
//   // isControlled is ignored in the hook dependency lists as it should never change.
//   const { current: isControlled } = React.useRef(controlled !== undefined);
//   const [valueState, setValue] = React.useState(defaultProp);
//   const value = isControlled ? controlled : valueState;
//   const setValueIfUncontrolled = React.useCallback((newValue) => {
//     if (!isControlled) {
//       setValue(newValue);
//     }
//   }, []);
//   return [value, setValueIfUncontrolled];
// }
